import { render, staticRenderFns } from "./FooterComp.vue?vue&type=template&id=30fdf76b&scoped=true"
import script from "./FooterComp.vue?vue&type=script&lang=js"
export * from "./FooterComp.vue?vue&type=script&lang=js"
import style0 from "./FooterComp.vue?vue&type=style&index=0&id=30fdf76b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fdf76b",
  null
  
)

export default component.exports